// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>2</span>&nbsp;&nbsp;Then was our mouth filled with laughter&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and our tongue with songs of joy.<br> </p> </div></div>";
// Exports
module.exports = code;